import React, { useEffect, useState } from "react";
import { Col, Container, Row, Nav, ProgressBar, Tabs } from "react-bootstrap";
import { FaUserAlt } from "react-icons/fa";
import Tab from "react-bootstrap/Tab";
import "../../assets/scss/pages/dashboard.scss";
import gradeBook from "../../assets/images/icons/gradebook-icon.png";
import YourCourse from "../../assets/images/icons/yourcoures-icon.png";
import DoubtClearingSessiions from "../../assets/images/icons/doubt-clearing-sessions-icon.png";
import Scheduler from "../../assets/images/icons/scheduler-icon.png";
import UserProfile from "../../assets/images/icons/user-profile-icon.png";
import Rewards from "../../assets/images/icons/rewards-icon.png";
import ImprovementSuggestions from "../../assets/images/icons/improvement-suggestions-icon.png";
import invoiceReceiptions from "../../assets/images/icons/invoice-and-receipticon.png";
import assignmentss from "../../assets/images/icons/assignments.png";
import activitys from "../../assets/images/icons/activitys.png";
import ProfileHeaderImg from "../../assets/images/prfile-header-img.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Loader from "../../features/Loader";
import ProfileEditor from "../../components/SettingsComponents/ProfileEditor";
import { fetchSubscribedCourse } from "../../store2/features/subscribedCourseSlice";
import CourseCard from "../../components/CourseCard";
import ApiService from "../../services/ApiService";
import SectionHeader from "../../components/SectionHeader";
import CourseSlider from "../../components/CourseSlider";
import AccountSecurity from "../../components/SettingsComponents/AccountSecurity";
// import Calendly from "../../components/Calendly/Calendly.jsx";
import Calendly from "../../components/Calendly/CalendlyComponent";
import InvoiceReceipt from "./UserDashboard/InvoiceReceipt";
import { IoArrowBack } from "react-icons/io5";
import QuizReport from "./UserDashboard/QuizReport";
import { FaPencil } from "react-icons/fa6";
import Assignments from "./UserDashboard/Assignments";
import GradeBook from "./UserDashboard/GradeBook";
import { callAlert } from "../../services/CommonService";
import { set } from "date-fns";

export default function Dashboard() {
  const [userDetails, setUserDetails] = useState(false);
  const [key, setKey] = useState("group");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const courses = useSelector(state => state.courses);
  // const loading = useSelector((state) => state.courses.loading);
  const status = useSelector((state) => state.courses.status);
  const errors = useSelector((state) => state.courses.errors);

  const course = useSelector((state) => state.subscribedCourses.items);
  const loading = useSelector((state) => state.subscribedCourses.loading);

  const [courses, setCourse] = useState();
  const [allCourses, setAllCourses] = useState();
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [courseLoaderStatus, setCourseLoaderStatus] = useState(true);
  const [allLoaderStatus, setAllLoaderStatus] = useState(true);

  const [profileEditable, setProfileEditable] = useState(false);
  const [lastVideoStatus, setLastVideoStatus] = useState("");

  const [activityView, setActivityView] = useState("youractivity"); //
  const [profileView, setProfileView] = useState("profile");
  const [loadAssignment, setLoadAssignment] = useState(false);

  useEffect(() => {
    let userDetailss = localStorage.getItem("userDetails");
    if (userDetailss) {
      setUserDetails(JSON.parse(userDetailss));
    }
  }, []);

  const scrollToId = (id) => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToTop = () => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    setTimeout(() => scrollToId("dashboard-view"), 1000); // wait for DOM render
  }, []);
  /*  social login  */

  useEffect(() => {
    console.log("Courses from dashboard", course);
    // console.log("Courses from length", course.length)
  }, [course]);

  useEffect(() => {
    dispatch(fetchSubscribedCourse());

    // dispatch(fetchAllCourses());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      setAllLoaderStatus(true);
      try {
        const response = await ApiService.publicGetRequest(
          "/courses/findallcourses"
        );
        setAllLoaderStatus(false);
        if (response.data?.data) {
          setAllCourses(response.data?.data);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchData();
    getLastVideoStatus();
  }, []);

  function formatCategoryAndGrade(userDetails) {
    // Convert category to lowercase
    const c = userDetails.category ? userDetails.category.toLowerCase() : "";

    // Replace space in grade with hyphen and convert to lowercase
    const g = userDetails.grade
      ? userDetails.grade.replace(/\s+/g, "-").toLowerCase()
      : "";
    console.log("grade", g);

    // Combine both with a hyphen
    return `${c}-${g}`;
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoaderStatus(true);
      if (userDetails) {
        try {
          const response = await ApiService.publicGetRequest(
            `/courses/findbysubcategory?subCategory=${formatCategoryAndGrade(
              userDetails
            )}`
          );
          setLoaderStatus(false);
          console.log("Response from Api", response);

          if (response.data.data) {
            setCourse(response.data.data);
            setCourseLoaderStatus(false);
          }
        } catch (error) {
          console.error("Error fetching courses:", error);
        }
      }
    };
    fetchData();
  }, [userDetails]);

  const [activeKey, setActiveKey] = useState("youractivity");

  const handleTabChange = (key) => {
    if (key === "quizReport") {
      setActiveKey("youractivity"); // Keep the parent tab open
      setActivityView("quizReport"); // Switch the internal view
      return; // Stop here so we don't set activeKey to "quizReport"
    }
    if (key == "gradeBook") {
      setActivityView("gradebook");
    }
    setActiveKey(key);
  };

  const getLastVideoStatus = () => {
    ApiService.publicGetRequest("/progress/lastVideoStatus", {}, false)
      .then((response) => {
        setLastVideoStatus(response?.data?.data);
      })
      .catch((error) => {
        //callAlert(error?.error?.message);
      });
  };

  const { page } = useParams();

  useEffect(() => {
    console.log("Pge", page);
    if (page === "QUIZ") {
      setActiveKey("youractivity");
      setActivityView("quizReport");
    }
    if (page === "ASSIGNMENT") {
      setActiveKey("assignments");
    }
    if (page === "user-profile") {
      setActiveKey("user-profile");
      // setActivityView("quizReport");
    }
  }, [page]);
  useEffect(() => {
    const title =
      userDetails.firstName + "'s" + " Dashboard" || "Loading Dashboard...";
    document.title = title;
  }, [userDetails]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : course && course.length > 0 ? (
        // true
        <section className="profice-wrap">
          <Container fluid="xl">
            <div className="main-body">
              <div className="profile-header-wrape">
                <Row className="align-items-center">
                  <Col lg={3}>
                    <div className="auth-image-wrap">
                      <div className="upload-image">
                        <label htmlFor="authimage" className="authlable">
                          <FaUserAlt />
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          id="authimage"
                          hidden
                        />
                      </div>
                    </div>
                  </Col>

                  <Col lg={9}>
                    <div className="profile-header-banner">
                      <Row className="align-items-center">
                        <Col lg={5}>
                          <div className="header-content">
                            {userDetails.newUser ? (
                              <h3 className="header-title">Welcome,</h3>
                            ) : (
                              <h3 className="header-title">Welcome Back,</h3>
                            )}
                            <h5 className="sub-title-header">
                              {userDetails.firstName} {userDetails.middleName}{" "}
                              {userDetails.lastName}
                            </h5>
                            <p className="text-header">
                              All-in-one dashboard to track your learning and
                              progress.
                            </p>
                          </div>
                        </Col>
                        <Col lg={7}>
                          <div className="images-header">
                            <img src={ProfileHeaderImg} alt="Img" />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>

              <Row>
                <Col lg={12}>
                  <div className="tab-wrapper-section">
                    <Tab.Container
                      id="left-tabs-example"
                      // defaultActiveKey="gradeBook"
                      activeKey={activeKey}
                      onSelect={(k) => setActiveKey(k)}
                    >
                      <Row>
                        <Col xl={3}>
                          <div className="left-menu">
                            <Nav
                              variant="pills"
                              className="flex-column navmenu-wrap"
                            >
                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="youractivity"
                                  onClick={() => {
                                    setActivityView("youractivity");
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={activitys}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">
                                    Your Activity
                                  </span>
                                </Nav.Link>
                              </Nav.Item>

                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="gradeBook"
                                  onClick={() => {
                                    setActivityView("gradebook");
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={gradeBook}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">GradeBook</span>
                                </Nav.Link>
                              </Nav.Item>

                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="yourcourses"
                                  onClick={() => {
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={YourCourse}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">
                                    Your Courses{" "}
                                  </span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="doubt-clearing-sessions"
                                  onClick={() => {
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={DoubtClearingSessiions}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">
                                    Doubt Clearing sessions
                                  </span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="assignments"
                                  onClick={() => {
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={assignmentss}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">Assignments</span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="improvement-suggestions"
                                  onClick={() => {
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={ImprovementSuggestions}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">
                                    Improvement suggestions{" "}
                                  </span>
                                </Nav.Link>
                              </Nav.Item>

                              {/* <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="scheduler"
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={Scheduler}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">
                                    One-on-One Session
                                  </span>
                                </Nav.Link>
                              </Nav.Item> */}

                              {/* <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="rewards"
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={Rewards}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">Rewards</span>
                                </Nav.Link>
                              </Nav.Item> */}

                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="user-profile"
                                  onClick={() => {
                                    setProfileView("profile");
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={UserProfile}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">
                                    User Profile{" "}
                                  </span>
                                </Nav.Link>
                              </Nav.Item>
                              {/* <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="account-security"
                                >
                                  <span className="icon-tabs">
                                    <img
                                      // src={UserProfile}
                                      className="icons-image"
                                      onClick={() =>
                                        setProfileView("account-security")
                                      }
                                    />
                                  </span>
                                  <span className="tab-name">
                                    Account Security{" "}
                                  </span>
                                </Nav.Link>
                              </Nav.Item> */}
                              <Nav.Item>
                                <Nav.Link
                                  className="navlink-tab"
                                  eventKey="invoice-receipt"
                                  onClick={() => {
                                    scrollToId("dashboard-view");
                                  }}
                                >
                                  <span className="icon-tabs">
                                    <img
                                      src={invoiceReceiptions}
                                      className="icons-image"
                                    />
                                  </span>
                                  <span className="tab-name">
                                    Invoice & Receipt{" "}
                                  </span>
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </div>
                        </Col>
                        <Col xl={9}>
                          <div className="right-content" id="dashboard-view">
                            <Tab.Content>
                              <Tab.Pane eventKey="youractivity">
                                {activityView === "youractivity" && (
                                  <>
                                    <div className="tab-content-body">
                                      <h3 className="tab-cont-title">
                                        Your Activity
                                      </h3>

                                      {lastVideoStatus?.lastViewedCourseId && (
                                        <div className="activity-items">
                                          <Row>
                                            <Col sm={2} className="pe-0">
                                              <div className="stutus-box">
                                                <p className="stutus-text">
                                                  Current Video
                                                </p>
                                              </div>
                                            </Col>
                                            <Col sm={7}>
                                              <div className="content-box">
                                                <h5 className="title-activity">
                                                  Watch next or resume video —
                                                  your learning continues here!
                                                </h5>
                                                <p className="para-activity">
                                                  Not watched full video?, no
                                                  problem, click and continue
                                                  your learning!
                                                </p>
                                                {/* <div className="progress-bar-activity">
                                                <ProgressBar now={60} />
                                              </div> */}
                                              </div>
                                            </Col>
                                            <Col sm={2} className="ms-auto">
                                              <div className="btn-activity">
                                                 {/* <Link to={`/course-details/${course.id}#course-details`}> */}
                                                <Link
                                                  to={
                                                    `/learning/${lastVideoStatus.lastViewedCourseId}`
                                                  }
                                                  onClick={() => scrollToTop()}
                                                  className="btn"
                                                >
                                                  Watch Video
                                                </Link>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      )}

                                      {loading ? (
                                        <Loader />
                                      ) : (
                                        course &&
                                        course.map((item, index) => (
                                          // <>
                                          <div
                                            className="activity-items"
                                            key={index}
                                          >
                                            <Row>
                                              <Col sm={2} className="pe-0">
                                                <div className="stutus-box">
                                                  <p className="stutus-text">
                                                    {item.course.board}
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col sm={7}>
                                                <div className="content-box">
                                                  <h5 className="title-activity">
                                                    {item.course.courseName}
                                                  </h5>
                                                  {/* <p className="para-activity">
                                                  {parse(String(item.summary))}
                                                </p> */}
                                                  {/* <div className="progress-bar-activity">
                                                  <ProgressBar now={0} />
                                                </div> */}
                                                </div>
                                              </Col>
                                              <Col sm={2} className="ms-auto">
                                                <div className="btn-activity">
                                                  <Link
                                                    to={`/learning/${item.course.courseId}`}
                                                    className="btn"
                                                    onClick={() =>
                                                      scrollToTop()
                                                    }
                                                  >
                                                    View
                                                  </Link>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                          // </>
                                        ))
                                      )}

                                      <div className="activity-items">
                                        <Row>
                                          <Col sm={2} className="pe-0">
                                            <div className="stutus-box">
                                              <p className="stutus-text">
                                                Doubt clearing
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={7}>
                                            <div className="content-box">
                                              <h5 className="title-activity">
                                                Upcoming doubt clearing sessions
                                              </h5>
                                              <p className="para-activity">
                                                Check your session with the
                                                teacher
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={2} className="ms-auto">
                                            <div className="btn-activity">
                                              <Link
                                                to="#"
                                                className="btn"
                                                onClick={() => {
                                                  handleTabChange(
                                                    "doubt-clearing-sessions"
                                                  );
                                                  scrollToId("dashboard-view");
                                                }}
                                              >
                                                View
                                              </Link>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* <div className="activity-items">
                                        <Row>
                                          <Col sm={2} className="pe-0">
                                            <div className="stutus-box">
                                              <p className="stutus-text">
                                                Modules/Videos
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={7}>
                                            <div className="content-box">
                                              <h5 className="title-activity">
                                                Upcoming Modules/Videos to watch
                                              </h5>
                                              <p className="para-activity">
                                                Module 9 left to watch 30 MB of
                                                400 MB
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={2} className="ms-auto">
                                            <div className="btn-activity">
                                              <Link
                                                to="#"
                                                className="btn"
                                                onClick={() =>
                                                  handleTabChange("yourcourses")
                                                }
                                              >
                                                View
                                              </Link>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div> */}

                                      <div className="activity-items">
                                        <Row>
                                          <Col sm={2} className="pe-0">
                                            <div className="stutus-box">
                                              <p className="stutus-text">
                                                Quiz
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={7}>
                                            <div className="content-box">
                                              <h5 className="title-activity">
                                                Quiz
                                              </h5>
                                              {/* <p className="para-activity">
                                                Quiz was not completed
                                              </p> */}
                                            </div>
                                          </Col>
                                          <Col sm={2} className="ms-auto">
                                            <div className="btn-activity">
                                              <button
                                                to="/quiz-report"
                                                className="btn"
                                                onClick={() =>
                                                  setActivityView("quizReport")
                                                }
                                              >
                                                View
                                              </button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>

                                      <div className="activity-items">
                                        <Row>
                                          <Col sm={2} className="pe-0">
                                            <div className="stutus-box">
                                              <p className="stutus-text">
                                                Grade
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={7}>
                                            <div className="content-box">
                                              <h5 className="title-activity">
                                                Overall Grade
                                              </h5>
                                              {/* <div className="progress-bar-activity">
                                                <ProgressBar now={60} />
                                              </div> */}
                                            </div>
                                          </Col>
                                          <Col sm={2} className="ms-auto">
                                            <div className="btn-activity">
                                              <Link
                                                to="#"
                                                className="btn"
                                                onClick={() => {
                                                  handleTabChange("gradeBook");
                                                  scrollToId("dashboard-view");
                                                }}
                                              >
                                                View
                                              </Link>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                      {/* <div className="activity-items">
                                        <Row>
                                          <Col sm={2} className="pe-0">
                                            <div className="stutus-box">
                                              <p className="stutus-text">
                                                Improvements
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={7}>
                                            <div className="content-box">
                                              <h5 className="title-activity">
                                                Suggested improvements
                                              </h5>
                                              <p className="para-activity">
                                                Give a breif overview of where
                                                they make common mistakes in the
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={2} className="ms-auto">
                                            <div className="btn-activity">
                                              <Link
                                                to="#"
                                                className="btn"
                                                onClick={() =>
                                                  handleTabChange(
                                                    "improvement-suggestions"
                                                  )
                                                }
                                              >
                                                Feedback
                                              </Link>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div> */}
                                    </div>
                                  </>
                                )}
                                {activityView === "quizReport" && (
                                  <>
                                    <div className="tab-content-body">
                                      {/* <button className="btn btn-"><IoArrowBack /></button> */}
                                      <h3 className="tab-cont-title">
                                        <IoArrowBack
                                          className="links "
                                          onClick={() => {
                                            setActivityView("gradebook");
                                            setActiveKey("gradeBook");
                                          }}
                                        />{" "}
                                        Quiz Report
                                      </h3>
                                    </div>
                                    <QuizReport />
                                  </>
                                )}
                              </Tab.Pane>

                              <Tab.Pane eventKey="gradeBook">
                                {activityView === "gradebook" && (
                                  <>
                                    <div className="tab-content-body">
                                      <h3 className="tab-cont-title">
                                        {" "}
                                        GradeBook{" "}
                                      </h3>
                                      <GradeBook
                                        outputChange={handleTabChange}
                                      />
                                    </div>
                                  </>
                                )}
                              </Tab.Pane>

                              <Tab.Pane eventKey="yourcourses">
                                <div className="tab-content-body">
                                  <h3 className="tab-cont-title">
                                    Your Courses
                                  </h3>

                                  {loading ? (
                                    <Loader />
                                  ) : (
                                    course &&
                                    course.map((item, index) => (
                                      // <>
                                      <div
                                        className="activity-items"
                                        key={index}
                                      >
                                        <Row>
                                          <Col sm={2} className="pe-0">
                                            <div className="stutus-box">
                                              <p className="stutus-text">
                                                {item.course.board}
                                              </p>
                                            </div>
                                          </Col>
                                          <Col sm={7}>
                                            <div className="content-box">
                                              <h5 className="title-activity">
                                                {item.course.courseName}
                                              </h5>
                                              {/* <p className="para-activity">
                                                  {parse(String(item.summary))}
                                                </p> */}
                                              {/* <div className="progress-bar-activity">
                                                  <ProgressBar now={0} />
                                                </div> */}
                                            </div>
                                          </Col>
                                          <Col sm={2} className="ms-auto">
                                            <div className="btn-activity">
                                              <Link
                                                to={`/learning/${item.course.courseId}`}
                                                className="btn"
                                              >
                                                View
                                              </Link>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                      // </>
                                    ))
                                  )}
                                </div>
                              </Tab.Pane>

                              <Tab.Pane eventKey="doubt-clearing-sessions">
                                <div className="tab-content-body">
                                  <h3 className="tab-cont-title">
                                    Doubt Clearing sessions
                                  </h3>

                                  <Tabs
                                    id="controlled-tab-example"
                                    activeKey={key}
                                    onSelect={(k) => setKey(k)}
                                    className="mb-3"
                                  >
                                    <Tab
                                      eventKey="group"
                                      title="Group sessions"
                                    >
                                      {userDetails.grade == "Class 10" && (
                                        <Calendly
                                          url={
                                            "https://calendly.com/efhfromhome-prosper-india/class-10th-doubt-clearing-group-session"
                                          }
                                        />
                                      )}

                                      {userDetails.grade == "Class 9" && (
                                        <Calendly
                                          url={
                                            "https://calendly.com/efhfromhome-prosper-india/class-9th-doubt-clearing-group-session"
                                          }
                                        />
                                      )}

                                      {userDetails.grade != "Class 9" &&
                                        userDetails.grade != "Class 10" && (
                                          <Calendly
                                            url={
                                              "https://calendly.com/efhfromhome-prosper-india"
                                            }
                                          />
                                        )}
                                    </Tab>
                                    <Tab
                                      eventKey="course"
                                      title="One-on-one Course session"
                                    >
                                      <Calendly
                                        url={
                                          "https://calendly.com/efhfromhome-prosper-india/one-one-session"
                                        }
                                      />
                                    </Tab>
                                    {/* <Tab
                                      eventKey="project"
                                      title="One-on-One project session"
                                    >
                                      <Calendly
                                        url={
                                          "https://calendly.com/efhfromhome-prosper-india"
                                        }
                                      />
                                    </Tab> */}
                                  </Tabs>
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="assignments">
                                <>
                                  <div className="tab-content-body">
                                    {/* <button className="btn btn-"><IoArrowBack /></button> */}
                                    <h3 className="tab-cont-title">
                                      Assignments
                                    </h3>
                                    {activeKey === "assignments" && (
                                      <Assignments />
                                    )}
                                  </div>
                                </>
                              </Tab.Pane>

                              <Tab.Pane eventKey="user-profile">
                                {profileView === "profile" && (
                                  <>
                                    <div className="tab-content-body">
                                      <h3 className="tab-cont-title">
                                        User Profile
                                      </h3>
                                      {!profileEditable && (
                                        <div className="d-flex justify-content-end">
                                          <div className="d-flex gap-2">
                                            <button
                                              className="btn btn-primary"
                                              onClick={() =>
                                                setProfileEditable(true)
                                              }
                                            >
                                              <FaPencil /> {""}
                                              Edit Profile
                                            </button>
                                            <button
                                              className="btn btn-primary"
                                              onClick={() =>
                                                setProfileView(
                                                  "account-security"
                                                )
                                              }
                                            >
                                              <FaPencil /> {""}
                                              Change Password
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                      <ProfileEditor
                                        editable={profileEditable}
                                        setEditable={setProfileEditable}
                                      />
                                    </div>
                                  </>
                                )}
                                {profileView === "account-security" && (
                                  <>
                                    <div className="tab-content-body">
                                      <h3 className="tab-cont-title">
                                        <IoArrowBack
                                          className="links "
                                          onClick={() =>
                                            setProfileView("profile")
                                          }
                                        />{" "}
                                        Account security
                                      </h3>
                                      <AccountSecurity
                                        setProfileView={setProfileView}
                                      />
                                    </div>
                                  </>
                                )}
                              </Tab.Pane>
                              {/* <Tab.Pane eventKey="account-security">
                                <div className="tab-content-body">
                                  <h3 className="tab-cont-title">
                                    User Profile
                                  </h3>
                                  <AccountSecurity />
                                </div>
                              </Tab.Pane> */}
                              <Tab.Pane eventKey="rewards">
                                <div className="tab-content-body">
                                  <h3 className="tab-cont-title">Rewards</h3>
                                  <div className="alert alert-info d-flex justify-content-center align-items-center">
                                    <h3 className="fw-bold">Coming soon</h3>
                                  </div>
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="improvement-suggestions">
                                <div className="tab-content-body">
                                  <h3 className="tab-cont-title">
                                    Improvement suggestions{" "}
                                  </h3>
                                  <div className="alert alert-info d-flex justify-content-center align-items-center">
                                    <h2 className="fw-bold">Coming soon</h2>
                                  </div>
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="invoice-receipt">
                                <div className="tab-content-body">
                                  <h3 className="tab-cont-title">
                                    Invoice & Receipt
                                  </h3>
                                  {activeKey === "invoice-receipt" && (
                                    <InvoiceReceipt />
                                  )}
                                </div>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      ) : (
        <div className="sectionWrapper pb-1">
          <Container>
            <div className="sectionheader pb-1">
              <h2 className="title">
                Recommended <span>Courses</span>
              </h2>
            </div>
            <Row>

              { courseLoaderStatus ? (
                <Loader />
              ) : courses && courses.length > 0 ? (
                courses.map((course, index) => (
                  <Col md={3} key={index}>
                    <CourseCard course={course} />
                  </Col>
                ))
              ) : (
                <div className="alert alert-info d-flex justify-content-center align-items-center">
                  <h3 className="fw-bold">
                    {userDetails?.grade} courses are coming soon
                  </h3>
                </div>
              )}
            </Row>
            <Row>
              <Col sm={12}>
                <div className="sectionheader pb-1">
                  <h2 className="title">
                    Other <span>Courses</span>
                  </h2>

                  {allLoaderStatus ? (
                    <Loader />
                  ) : (
                    <CourseSlider dataCourse={allCourses} />
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
}
